import { motion } from "framer-motion";
import { ArrowUpRight, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative pt-24 md:pt-36 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <motion.a
          href="#contact"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8 }}
          className="group block"
          data-testid="footer-cta"
        >
          <span className="flex items-center justify-between border-b border-white/10 pb-6">
            <span className="font-display font-bold uppercase leading-none text-[13vw] md:text-[9rem] tracking-tight group-hover:text-gold transition-colors duration-500">
              Let's Work
            </span>
            <ArrowUpRight className="w-10 h-10 md:w-20 md:h-20 text-gold transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2" />
          </span>
        </motion.a>

        <div className="mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <img src="/assets/osh-logo.jpeg" alt="OSHPerformance — personal training gym Northwood" className="h-14 w-auto object-contain" data-testid="footer-logo" />
          <nav className="flex flex-wrap gap-8" data-testid="footer-nav">
            {[
              { label: "About", href: "#method" },
              { label: "Gallery", href: "#gallery" },
              { label: "Programs", href: "#programs" },
              { label: "Contact", href: "#contact" },
            ].map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="font-display uppercase tracking-[0.2em] text-sm text-zinc-500 hover:text-gold transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <div className="flex items-center gap-5">
            <a
              href="https://instagram.com/_oshperformance"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="OSHPerformance on Instagram"
              className="flex items-center gap-2 font-display uppercase tracking-[0.2em] text-sm text-zinc-500 hover:text-gold transition-colors duration-300"
            >
              <Instagram className="w-5 h-5" /> @_oshperformance
            </a>
          </div>
          <p className="text-zinc-600 text-xs tracking-wide" data-testid="footer-copyright">
            © {new Date().getFullYear()} OSHPerformance. Hit your target. Every time.
          </p>
        </div>
      </div>
    </footer>
  );
}
